import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/commercial/commercial-workspace.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/commercial/commercial-reading.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/commercial/CommercialHeader.tsx");
